import React from "react";
import Banner from "../Components/Banner";
import { AiOutlineFundProjectionScreen } from "react-icons/ai";
import { RiExternalLinkFill } from "react-icons/ri";
import Card from "../Components/UI/Card";
import { Link } from "react-router-dom";
import { ImRocket } from "react-icons/im";
const ProjectData = [
  {
    name: "Airbnb clone",
    imgName: "Airbnb",
    liveLink: "https://10-react-airbnb-clone.vercel.app/",
  },
  {
    name: "Contact app",
    imgName: "Contactapp",
    liveLink: "https://contacts-directory.vercel.app/",
  },
  {
    name: "Al-pakeezo website",
    imgName: "HalalOPakeeza",
    liveLink: "https://halalopakeeza.com/",
  },
  {
    name: "Food Order App",
    imgName: "FoodOrderApp",
    liveLink: "https://react-food-order-app-mansoorcode.vercel.app/",
  },
  {
    name: "Filter Product",
    imgName: "FilterProduct",
    liveLink: "https://filter-product-gamma.vercel.app/",
  },
  {
    name: "Country Card",
    imgName: "CountryCard",
    liveLink: "https://country-card.vercel.app/",
  },
  {
    name: "Counter app",
    imgName: "CounterApp",
    liveLink: "https://redux-practice-git-new-branch2-mansoorcode.vercel.app/",
  },
  {
    name: "Rick and Morty",
    imgName: "RickAndMorty",
    liveLink: "https://rick-and-morty-mansoorcode.vercel.app/",
  },
  {
    name: "React Route",
    imgName: "ReactRoute",
    liveLink: "https://react-route-alpha.vercel.app/quotes",
  },
  {
    name: "Random Color",
    imgName: "RandomColor",
    liveLink: "https://mansoorcode.github.io/19-random-color-generator-Js/",
  },
  {
    name: "Responsive Clock",
    imgName: "ResponsiveClock",
    liveLink: "https://mansoorcode.github.io/18-Small-Clock/",
  },

  {
    name: "Water Wave Animation",
    imgName: "WaterWaveAnimation",
    liveLink: "https://mansoorcode.github.io/05-water-wave-animation/",
  },
  // {
  //   name: "Notebook",
  //   imgName: "Notes",
  //   liveLink: "https://osama478.github.io/01-css-notes-project/",
  // },
  {
    name: "Grid Layout",
    imgName: "GridLayout",
    liveLink:
      "https://mansoorcode.github.io/03-css-grid-responsive-massonry-layout/",
  },
  {
    name: "Responsive Card",
    imgName: "ResponsiveCard",
    liveLink: "https://mansoorcode.github.io/16-responsive-card-ui-design/",
  },

  {
    name: "Product Card",
    imgName: "ProducCard",
    liveLink: "https://mansoorcode.github.io/13-product-design/",
  },
];
const Project = ({ homeElement }) => {
  return (
    <div className="p-2 md:pl-[17rem]  md:p-4 h-[calc(100vh-4rem)] pt-[6rem] overflow-scroll">
      <Banner homeElement={homeElement} />
      <div className="flex items-center justify-center gap-4 my-2 md:mt-4 md:gap-8">
        <ImRocket className="w-8 h-8 md:h-10 md:w-10" />
        <h1 className="text-2xl text-center underline md:text-4xl underline-offset-8">
          Projects
        </h1>
      </div>
      <Card>
        <div className="grid grid-cols-1 gap-6 p-4 lg:gap-10 lg:p-10 place-items-center lg:grid-cols-2">
          {ProjectData.map((project) => (
            <div
              className="h-full w-72 md:w-96 lg:w-full "
              key={`${project.name}`}
            >
              <Card glareEnable="true" tiltEnable="true" glareMaxOpacity={0.4}>
                <div className="relative w-full h-48  bg-black hover:-translate-y-[100%] transition duration-300 ease-in-out">
                  <div className="absolute top-0 w-full h-48 bg-slate-500">
                    <img
                      src={require(`../Assets/img/Project/${project.imgName}.png`)}
                      className="w-full h-full"
                      alt="project"
                    />
                  </div>

                  <div className="absolute grid place-items-center top-[100%] w-full h-48 bg-slate-500">
                    <Link
                      to={project.liveLink}
                      target="_blank"
                      className="flex flex-col items-center justify-center text-4xl text-white hover:text-green-400"
                    >
                      <h1 className="text-2xl">{project.name}</h1>
                      <RiExternalLinkFill />
                    </Link>
                  </div>
                </div>
              </Card>
            </div>
          ))}
        </div>
      </Card>
    </div>
  );
};

export default Project;
